import { status } from '../../../../constants/attendanceStatus'

export interface AttendanceCounts {
  yes: number
  maybe: number
  no: number
  unknown: number
  total: number
}

export const getAttendanceCounts = (players: any[]): AttendanceCounts => {
  const counts: AttendanceCounts = {
    yes: 0,
    maybe: 0,
    no: 0,
    unknown: 0,
    total: players.length,
  }
  for (const player of players) {
    switch (player?.attendance_status) {
      case status.ATTENDING:
        counts.yes++
        break
      case status.NOT_ATTENDING:
        counts.no++
        break
      case status.MAYBE:
        counts.maybe++
        break
      default:
        counts.unknown++
    }
  }
  return counts
}
